<script lang="ts" setup>
import { useArticleStore } from '@/stores'

const props = defineProps({
  categoryId: {
    type: String as PropType<any>,
    default: null,
  },
})

const articleStore = useArticleStore()
const categories = computed(() => articleStore.getNewsCategories)
</script>

<template>
  <ul class="classlink">
    <li :class="{ 'classlink-active': categoryId == null }">
      <nuxt-link to="/news">消息總覽</nuxt-link>
    </li>
    <li v-for="(category, index) in categories" :key="category.id"
      :class="{ 'classlink-active': category.id == categoryId }">
      <nuxt-link :to="`/news/${category.seo.meta_slug || category.id}`">{{
        category.subject
      }}</nuxt-link>
    </li>
  </ul>
</template>

<style lang="scss" scoped></style>
